// Service
export const REMOTECLIENTS_CALLS = 'remoteclients.calls';
export const UBFF_REMOTECLIENTS_CALLS = 'ubff.remoteclients.calls';
export const PAGELOAD_SUCCESS = 'pageLoad.success';
export const PAGELOAD_FAILURE = 'pageLoad.failure';
export const COMPONENTLOAD_FAILURE = 'componentLoad.failure';

// Search
export const SEARCH_CLICKED = 'search_clicked';
export const SEARCH_SUMITTED = 'search_sumitted';
export const SEARCH_VALIDATION_FAILED = 'search_validation_failed';
export const SEARCH_START = 'search_start';
export const SEARCH_FAST_SUCCESS = 'search_fast_success';
export const SEARCH_SUCCESS = 'search_success';
export const SEARCH_EMPTY = 'search_empty';
export const SEARCH_FAILURE = 'search_failure';
export const MOUNT_SEARCH_CYCLE = 'mount search cycle';

// AUTOSUGGEST
export const CONTROLS_ACTIVATED = 'CONTROLS_ACTIVATED';
export const RESULT_SELECTED = 'RESULT_SELECTED';
export const CONTROLS_DISMISSED = 'CONTROLS_DISMISSED';
export const RESULTS_UPDATED = 'RESULTS_UPDATED';
export const AUTOSUGGEST_SEARCH = 'AUTOSUGGEST_SEARCH';

// Prices
export const UBFF_PRICES_START = 'ubff.prices.start';
export const UBFF_PRICES_SUCCESS = 'ubff.prices.success';
export const UBFF_PRICES_EMPTY = 'ubff.prices.empty';
export const UBFF_PRICES_FAILURE = 'ubff.prices.failure';

// Others
export const ATYPICAL_PRICES_POC_MEET_SPECIFIC_USER_ACTIONS =
  'Atypical prices poc meet specific user actions';
export const ATYPICAL_PRICES_POC_HAS_MEDIAN_MIN_PRICE =
  'Atypical prices poc has median_min_price';
export const ATYPICAL_PRICES_POC_DOES_NOT_MEET_SPECIFIC_USER_ACTIONS =
  'Atypical prices poc does not meet specific user actions';

//  Price insights
export const PRICE_INSIGHTS_REQUEST = 'price_insights.request';
